import { useSportsSettings } from '@namespace/cms';
import { STREAM_PLAYER_TYPE, STREAM_TYPE } from '@namespace/common';
import { MODE } from '../../constants';
import { useEventFields } from '../../store';
import { useIsBroadcastEnabledForSport } from '../useIsBroadcastEnabledForSport';

export const useVideoStreamInfo = ({ eventId }) => {
  const { showPaidVideos = true, isShowVideo: isShowVideoBySettings = true } =
    useSportsSettings();
  const { broadcast, eventBroadcastUrl, sportId, eventTv, serviceId } =
    useEventFields({
      eventId,
      fields: [
        'broadcast',
        'eventBroadcastUrl',
        'sportId',
        'eventTv',
        'serviceId'
      ]
    });
  const isLive = serviceId === MODE.IN_PLAY;
  const isSportBroadcastEnabled = useIsBroadcastEnabledForSport(sportId);

  let streamType = null;
  let streamPlayerType = null;
  let isVideoFree = false;
  if (broadcast != null) {
    streamType = STREAM_TYPE.BROADCAST;
    streamPlayerType = STREAM_PLAYER_TYPE.PLAYER;
  } else if (isSportBroadcastEnabled && eventBroadcastUrl) {
    streamType = STREAM_TYPE.TWITCH;
    streamPlayerType = STREAM_PLAYER_TYPE.IFRAME;
    isVideoFree = true;
  } else if (eventTv?.countries?.length > 0) {
    streamType = STREAM_TYPE.FAVTV;
    streamPlayerType = STREAM_PLAYER_TYPE.PLAYER;
    isVideoFree = Boolean(eventTv?.isFta);
  }

  const isShowVideo =
    isLive &&
    isShowVideoBySettings &&
    (showPaidVideos || isVideoFree) &&
    streamType != null;

  return {
    isShowVideo,
    isVideoFree,
    streamType,
    streamPlayerType
  };
};
